import React from "react";
import CreditCard from "../../shared/CreditCard";
import BoxWithRadioSelect from "./BoxWithRadioSelect";
import DeleteButton from "./icons/DeleteButton";
import styles from "./BoxWithRadioSelect.module.scss";

const CreditCardWithSelection = (props) => {
  const { onDelete } = props;

  let fnSelection = () => props.onSelect(props.id);

  let headerText = null;

  const isCurrentCard = props.id === "current";

  const handleDelete = onDelete && ((e) => {
    e.stopPropagation();
    onDelete(props.id);
  });

  headerText = <React.Fragment>
    { headerText }
    <div className={styles.headerRight}>
      { <DeleteButton onClick={handleDelete} /> }
    </div>
  </React.Fragment>
  
  return (
    <BoxWithRadioSelect selected={props.selected}
      onSelect={fnSelection}
      headerText={headerText}>
      <CreditCard card={props.card} isCurrent={isCurrentCard} />
    </BoxWithRadioSelect>
  );
}

export default CreditCardWithSelection;